import { z } from "zod";
import {
  KycSchema,
  PreReviewDocumentSchema,
  RelationshipSchema,
  TaxResidenceSchema,
  UserSchema,
} from "../treezor/index.js";

export default {
  params: z.object({
    accountId: z.string(),
  }),
  response: z.array(
    z.object({
      user: UserSchema.extend({ kyc: KycSchema.optional() }),
      documents: z.array(PreReviewDocumentSchema),
      taxResidences: z.array(TaxResidenceSchema),
      relationships: z.array(RelationshipSchema).min(1),
    }),
  ),
};
